import { RegistrationAttributesServant } from '../servants/registration_attributes_servant';
import { SectionRegistrationAttributesQuery } from '../queries/section_registration_attributes_query';
import { ISection, HILForm } from '../../interfaces/scheduler_interfaces';
import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { SectionRegistrationAttributesFormOutputModel } from '../models/section_registration_attributes_form_output_model';
import { RegistrationAttributesFacade } from '../facades/registration_attributes_facade';

export type SubmitRegAttrFormAndGetOutputCommand = (
  formElement: HILForm,
  formId: HILForm['id'],
  sectionIds: Array<ISection['id']>
) => ng.IPromise<undefined | Record<string, any>>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'submitRegAttrFormAndGetOutputCommand',
    (
      defineCommand: IDefineCommand,
      ngSectionRegistrationAttributesFormOutputModel: SectionRegistrationAttributesFormOutputModel,
      ngSectionRegistrationAttributesQuery: SectionRegistrationAttributesQuery,
      ngRegistrationAttributesFacade: RegistrationAttributesFacade
    ) =>
      defineCommand(
        'submitRegAttrFormAndGetOutputCommand',
        (deferred, formElement: HILForm, formId: HILForm['id'], sectionIds: Array<ISection['id']>) => {
          const regAttributesFeatureEnabled = ngRegistrationAttributesFacade.isFeatureEnabled();
          if (!regAttributesFeatureEnabled) {
            deferred.resolve();
            return;
          }

          const prevFormOutput = ngSectionRegistrationAttributesFormOutputModel.read();
          const selectionRecordExist = prevFormOutput.id === formId;
          if (!formElement && selectionRecordExist) {
            deferred.resolve(prevFormOutput.output);
            return;
          }
          ngSectionRegistrationAttributesFormOutputModel.clear();
          if (!formElement && !selectionRecordExist) {
            deferred.reject();
            return;
          }

          const isEmptyForm = sectionIds.every((sectionId) =>
            _4.isEmpty(_4.get(ngSectionRegistrationAttributesQuery.result[sectionId], 'attributes.properties'))
          );
          if (isEmptyForm) {
            deferred.resolve({});
            return;
          }
          const formElementOutput = formElement.output;
          const isFormValid = !_4.isEmpty(formElementOutput);
          if (!isFormValid || !formElementOutput) {
            deferred.reject();
            return;
          }
          const formOutput = RegistrationAttributesServant.formRegAttributeApiParamFromFormOutput(formElementOutput);
          ngSectionRegistrationAttributesFormOutputModel.write({
            id: formId,
            output: formOutput
          });
          deferred.resolve(formOutput);
          return;
        }
      )
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_attributes/commands/submit_reg_attr_form_and_get_output_command.ts